<form [formGroup]="form">
    <app-form-error [error]="error" />

    @if (sellMode()) {
        <div class="agent-add-card-form-client">
            <form-checkbox
                class="mb-3"
                [formControlName]="addCardFormField.AddCardForClient"
                [label]="'form.labels.forClient' | translate" />

            @if (forExistingClient && !client()) {
                <button type="button" matButton="filled" (click)="preventDefault($event); openDialogSearchClient()">
                    {{ 'components.add-card.selectClient' | translate }}
                </button>
            }
        </div>
    }

    <form-select
        [formControlName]="addCardFormField.MediumType"
        [label]="'form.labels.mediumType' | translate"
        [options]="mediumTypes()" />

    <form-input [formControlName]="addCardFormField.MediumN" [label]="'form.labels.mediumN' | translate" />

    <form-input [formControlName]="addCardFormField.TopupSum" [label]="'form.labels.sum' | translate" />

    <form-select
        [formControlName]="addCardFormField.PaymentType"
        [label]="'form.labels.paymentType' | translate"
        [options]="paymentTypes"
        [translateOptions]="true" />

    @if (
        (topUpValue && topUpControl?.status === 'VALID') ||
        (mediumControlValue.status === 'VALID' && mediumTypeControlValue.status === 'VALID')
    ) {
        <app-price-block
            [price]="topUpValue"
            [sellWithRegistrationFlag]="sellMode() && forExistingClient"
            [product]="sellMode() ? product.SellCard : product.RegisterCard"
            [sellerSettings]="sellerSettings()" />
    }

    <form-checkbox
        class="mb-3"
        [formControlName]="addCardFormField.PaymentAccepted"
        [label]="'form.labels.paymentAccepted' | translate" />

    <form-button
        [disabled]="form.status === 'INVALID' || form.status === 'PENDING'"
        [label]="'actions.submit' | translate"
        [loading]="form.status === 'PENDING'"
        [wide]="true"
        (handlerClick)="handlerSubmit()" />
</form>
